import { getImageUrl } from "../../../../../helpers/PB";

const ReportTemplateConfig = {
  collection: "report_template",
  single: true,
  fields: [
    "id",
    "header",
    "savings_estimate_header",
    "savings_estimate_description",
    "consumption_header",
    "cost_header",
    "savings_summary_header",
    "savings_summary_full_description",
    "savings_summary_simplified_description",
    "emissions_header",
    "emissions_subheader",
    "emissions_image.id",
    "trees_header",
    "trees_subheader",
    "trees_image.id",
    "smartphones_header",
    "smartphones_subheader",
    "smartphones_image.id",
    "marketing_banner.id",
    "marketing_banner_url",
    "calculations_header",
    "calculations_description",
    "calculation_table_columns",
    "disclaimers_section_text"
  ],

  adapter: class ReportTemplate {
    constructor(reportTemplate) {
      Object.assign(this, reportTemplate);
      this.emissions_image = getImageUrl(this.emissions_image?.id);
      this.trees_image = getImageUrl(this.trees_image?.id);
      this.smartphones_image = getImageUrl(this.smartphones_image?.id);
      this.marketing_banner = getImageUrl(this.marketing_banner?.id);
    }
  }
};

export default ReportTemplateConfig;
